// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__VhU2m","richTextCount":"RichText_richTextCount__3PHVx"};